import { useSelector } from 'react-redux';
import type { RootState } from '../store/models';

export const useAllowSuperUser = (allowSuperUser: boolean = false): boolean => {
  const isSuperUser = useSelector((state: RootState) => state.user?.is_superuser);

  return !isSuperUser || (isSuperUser && allowSuperUser);
};
